import { ColorBalanceFilter } from "../../../operations/filters/colorBalance.js";
import { GLProgram } from "../../../program.js";
export class ColorBalanceProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/colorBalance/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/colorBalance/fragment.glsl');
        var result = new ColorBalanceProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['highlights'] = gl.getUniformLocation(result._program, 'u_highlights');
        result._uniforms['midtones'] = gl.getUniformLocation(result._program, 'u_midtones');
        result._uniforms['shadows'] = gl.getUniformLocation(result._program, 'u_shadows');
        result._uniforms['preserve_luminosity'] = gl.getUniformLocation(result._program, 'u_preserve_luminosity');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        return result;
    }

    setUniforms(parameters: ColorBalanceFilter) {
        var self = this;
        self._gl.uniform2f(self.uniformLocation('texture_size'), parameters._width, parameters._height);
        self._gl.uniform3fv(self.uniformLocation('highlights'), parameters.highlights);
        self._gl.uniform3fv(self.uniformLocation('midtones'), parameters.midtones);
        self._gl.uniform3fv(self.uniformLocation('shadows'), parameters.shadows);
        self._gl.uniform1i(self.uniformLocation('preserve_luminosity'), parameters.preserve_luminosity);
    }

}